"use client";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AppProgressProvider as ProgressProvider } from '@bprogress/next';
import { ReactNode } from "react";
import 'dayjs/locale/en-gb';

const ClientProviders = ({ children }: { children: ReactNode }) => {

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
      <ProgressProvider
        height="4px"
        color="rgba(33, 79, 206, 1)"
        // options={{ showSpinner: false }}
        shallowRouting
        >
        {children}
      </ProgressProvider>
    </LocalizationProvider>
  );
};

export default ClientProviders;